<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <div class="md-layout-item md-size-20 no-padding">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>publish</md-icon>일괄 처리 입력
            </h4>
          </md-card-header>
          <md-card-content>
            <div class="flex-div">
              <h5 class="title">엑셀 업로드</h5>

              <!--<div class="inline-flex mb10">
                <select>
                  <option>자택주소</option>
                  <option>휴대폰</option>
                  <option>이메일</option>
                </select>
              </div>-->
              <div class="inline-flex mb10">
                <input v-focus type="file" class="hidden-input-file" id="bundleFileInput" accept=".xlsx">
                <input type="text" v-model="excelFileName" disabled>
                <button @click="onClickSearchExcel">
                  <md-icon>search</md-icon>엑셀 파일 찾기
                </button>
              </div>
              <md-button class="md-success md-sm full-size-button" @click="uploadExcelFile" :disabled="!excelFile">
                <md-icon>publish</md-icon>엑셀 업로드
              </md-button>
            </div>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-size-80 no-padding">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>assignment</md-icon>조회 결과
            </h4>
          </md-card-header>
          <md-card-content>
            <div class="table-header-info">
              <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
              <div>
                <select v-model="pagination.perPage" name="pages" @change="perPageChange">
                  <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                    {{ item }}
                  </option>
                </select>
              </div>
            </div>
            <grid ref="executivesGrid"
                  :data="gridProps.data"
                  :columns="gridProps.columns"
                  :options="gridProps.options"
                  :theme="gridProps.theme"
                  :rowHeaders="gridProps.rowHeaders"
                  :columnOptions="gridProps.columnOptions"
                  :language="gridProps.lang"
            ></grid>
          </md-card-content>
          <md-card-actions md-alignment="right">
            <div>
              <md-button class="md-info md-sm" @click.native="runBundleUpdate('basic')" :disabled="tableData.length === 0">
                <md-icon>done_all</md-icon>
                일괄 업데이트
              </md-button>
            </div>
          </md-card-actions>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import axios from "axios";
import URL_CONST from "@/kuaa/kuaa-url-const";
import parser from "@/kuaa/kuaa-parser";
import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import kuaaApi from "@/kuaa/kuaa-api";

export default {
  components: {
    grid: Grid,
  },

  created() {
    this.initGrid();
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },

  data() {
    return {
      excelFile: null,
      excelFileName: null,
      pagination: {
        perPage: 20,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 500],
        total: 0
      },
      tableData: []
    };
  },
  methods: {
    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(null, false, this.pagination);
      this.gridProps['el'] = this.$refs.executivesGrid;
      this.gridProps['columns'] = [
        {header: '교우번호', name: 'memberNo', sortable: true},
        {header: '도로명여부', name: 'homeGb', sortable: true},
        {header: '우편번호', name: 'homeZipcd', sortable: true},
        {header: '주소 1', name: 'homeAddress1', sortable: true},
        {header: '주소 2', name: 'homeAddress2', sortable: true},
        {header: '휴대폰', name: 'cellular', sortable: true},
        {header: '이메일', name: 'eMail', sortable: true},
      ];
      this.gridProps['data'] = [];
    },

    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.executivesGrid, event, this.pagination);
    },

    onClickSearchExcel() {
      let input = document.getElementById("bundleFileInput");
      input.onchange = e => {
        let file = e.target.files[0];
        this.excelFileName = file.name;
        this.excelFile = file;
      };
      input.click();
    },

    uploadExcelFile() {
      parser.parseXlsMemberBundleData(this.excelFile, (res) => {
        let temp = [];

        res.forEach((item, i) => {
          if (i === 0) {  // 첫번째 row 는 제목이라서 추가하지 않음
            return;
          }

          temp.push({
            id: i,
            memberNo: item[0],
            homeGb: item[1],
            homeZipcd: item[2],
            homeAddress1: item[3],
            homeAddress2: item[4],
            cellular: item[5],
            eMail: item[6]
          });
        });

        this.tableData = temp;
        this.pagination.total = this.tableData.length;

        this.$refs.executivesGrid.invoke("clear");
        this.$refs.executivesGrid.invoke("appendRows", this.tableData);
      });
    },

    // 일괄 등록 서버에 전송
    runBundleUpdate(type) {
      Swal.fire(kuaaFnc.getSwalModaloptions('confirm', {title: "일괄 업데이트"})).then(result => {
        if (result.value) {
          let option = [];
          this.tableData.forEach((item) => {
            option.push({
              memberNo: item.memberNo,
              homeGb: item.homeGb,
              homeZipcd: item.homeZipcd,
              homeAddress1: item.homeAddress1,
              homeAddress2: item.homeAddress2,
              cellular: item.cellular,
              eMail: item.eMail
            });
          });

          kuaaApi.sendServer(
              URL_CONST.SAVE_MEMBER_BATCH,
              option,
              "post",
              res => {
                if (res.data.success) {
                  this.tableData = [];
                  this.pagination.total = 0;

                  this.$refs.executivesGrid.invoke("clear");
                  this.$refs.executivesGrid.invoke("appendRows", this.tableData);

                  kuaaFnc.showSwal('교우일괄 처리', '일괄 업데이트 되었습니다.');
                }
              }
          );
        }
      });
    }
  }
}
</script>

<style>

</style>